var exports = {
  "q": "xa15a2ab7--bd658a--price",
};

module.exports = exports;
